import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const LocationIcon = (props: IconProps) => (
  <Icon w={20} h={20} viewBox="0 0 20 20" {...props}>
    <path d="M9.99984 1.6665C6.77484 1.6665 4.1665 4.27484 4.1665 7.49984C4.1665 11.8748 9.99984 18.3332 9.99984 18.3332C9.99984 18.3332 15.8332 11.8748 15.8332 7.49984C15.8332 4.27484 13.2248 1.6665 9.99984 1.6665ZM5.83317 7.49984C5.83317 5.19984 7.69984 3.33317 9.99984 3.33317C12.2998 3.33317 14.1665 5.19984 14.1665 7.49984C14.1665 9.89984 11.7665 13.4915 9.99984 15.7332C8.2665 13.5082 5.83317 9.87484 5.83317 7.49984Z" />
    <path d="M9.99984 9.58317C11.1504 9.58317 12.0832 8.65043 12.0832 7.49984C12.0832 6.34924 11.1504 5.4165 9.99984 5.4165C8.84924 5.4165 7.9165 6.34924 7.9165 7.49984C7.9165 8.65043 8.84924 9.58317 9.99984 9.58317Z" />
  </Icon>
);

export default memo(LocationIcon);
